import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Tabs } from 'shared/ui'
import { VoicesContent } from 'widgets/TextToSpeech/ui/TextToSpeechVoice/VoicesContent/VoicesContent'
import { type GreetingVoiceConfigStore } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/Greeting/store/GreetingVoiceConfigStore'

export const GreetingVoicesContent = observer(
  ({ onCloseMenu, store }: { onCloseMenu: () => void; store: GreetingVoiceConfigStore }) => {
    const {
      search,
      setSearch,
      tabs,
      voices,
      activeTabKey,
      setActiveTabKey,
      getVoicePreview,
      onErrorLoadPreview,
    } = store
    useEffect(() => {
      return () => {
        setSearch('')
      }
    }, [])
    return (
      <VoicesContent
        onCloseMenu={onCloseMenu}
        search={search}
        setSearch={setSearch}
        tabContent={
          <Tabs
            tabs={tabs}
            activeTabKey={activeTabKey}
            handleSelectTab={(tab) => setActiveTabKey(tab.key)}
          />
        }
        voices={voices}
        voiceItemProps={() => ({
          getVoicePreview,
          onErrorLoadPreview,
        })}
      />
    )
  }
)
